'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import FinderActionsDropdown from 'DesignFinderUI/components/actions/FinderActionsDropdown';

const i18nKey = key => `DesignFinderUI.actions.ViewActionsDropdown.${key}`;

export default class ViewActionsDropdown extends PureComponent {
  render() {
    const {
      disabled,
      hasSelections,
      onCollapseAllFolders,
      onDeselectAll,
      onShowRecentlyDeleted,
      onShowRecentlyEdited,
      openFoldersCount
    } = this.props;
    return /*#__PURE__*/_jsx(FinderActionsDropdown, {
      buttonText: text(i18nKey('buttonText')),
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: !openFoldersCount,
          onClick: onCollapseAllFolders,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.collapseFolders')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          disabled: !hasSelections,
          onClick: onDeselectAll,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.deselect')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onShowRecentlyDeleted,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.recentlyDeleted')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onShowRecentlyEdited,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.recentlyEdited')
          })
        })]
      })
    });
  }

}
ViewActionsDropdown.displayName = 'ViewActionsDropdown';
ViewActionsDropdown.propTypes = {
  disabled: PropTypes.bool,
  hasSelections: PropTypes.bool,
  onCollapseAllFolders: PropTypes.func,
  onDeselectAll: PropTypes.func,
  onShowRecentlyDeleted: PropTypes.func,
  onShowRecentlyEdited: PropTypes.func,
  openFoldersCount: PropTypes.number
};
ViewActionsDropdown.defaultProps = {
  disabled: false,
  hasSelections: false,
  onCollapseAllFolders: emptyFunction,
  onDeselectAll: emptyFunction,
  onShowRecentlyDeleted: emptyFunction,
  onShowRecentlyEdited: emptyFunction,
  openFoldersCount: 0
};